let localAssignmentData = []; 

if(localStorage.getItem('my_assignment_data') !== undefined){ 
    localAssignmentData = JSON.parse(localStorage.getItem('my_assignment_data'));
}
 

const assignmentData = (state = localAssignmentData, action) => {
    switch(action.type){
        case 'MYASSIGNMENT_RECEIVE_DATA_API':
            state = action.payload;
            state.map((item) =>  item.is_open = false)  
            localStorage.setItem('my_assignment_data',JSON.stringify(state))
            return state; 
        case 'UPDATE_LAB_REPORT_DATA':
            let updateIndexValue = state.findIndex(item => item._id === action.payload._id); 
             if(updateIndexValue >= 0){
                state[updateIndexValue].first_name =  action.payload.first_name;   
                state[updateIndexValue].last_name =  action.payload.last_name;   
                state[updateIndexValue].relationship =  action.payload.relationship;   
                state[updateIndexValue].date_of_birth =  action.payload.date_of_birth;   
                return state; 
             }
        case 'MYASSIGNMENT_TOGGLE':
                let indexValue = action.payload;
                const updateArray = [...state]; 
                let areWeOpen;
                //check if already open we need to close the toggle
                if(updateArray[indexValue].is_open === true){
                    areWeOpen = false; 
                }else{
                    areWeOpen = true;  
                } 
                state.map((item) =>  item.is_open = false)
                state[indexValue].is_open = areWeOpen; 
          return [...state]; 

        case 'MYASSIGNMENT_SEARCH':
            const text = action.payload;
            const allData = JSON.parse(localStorage.getItem('my_assignment_data'));
            const filterData = allData.filter(item => {      
                let itemData = `${item.patient.first_name.toUpperCase()+item.patient.last_name.toUpperCase()+item.patient.mobile_number}`; 
                let textData = text.toUpperCase(); 
                return itemData.indexOf(textData) > -1;    
            });  
            state = filterData;  
            return state;  

      
 
        case 'DELETE_LAB_REPORT_DATA':
            let deleteIndexValue = state.findIndex(item => item._id === action.payload);  
            state.splice(deleteIndexValue, 1);  
            return [...state]; 
        default:
              return state;

    }
};

export default assignmentData;